"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchSaveUserSessionSuccess = watchSaveUserSessionSuccess;
exports.watchSendRecommendation = watchSendRecommendation;
var _effects = require("redux-saga/effects");
var _shareRecommendationActions = require("./shareRecommendationActions");
var _userActions = require("../user/userActions");
var _userSelectors = require("../user/userSelectors");
function* sendRecommendation(action) {
  yield (0, _effects.put)({
    ...(0, _shareRecommendationActions.saveShareData)(action.payload),
    instanceId: action.instanceId
  });
  yield (0, _effects.put)({
    type: _userActions.SAVE_USER_SESSION,
    payload: {
      nextQuestionIndex: -1
    },
    instanceId: action.instanceId
  });
}
function* handleShareRecommendationResponse(action) {
  var _userSession$characte, _parsedSessionState$s;
  const userSession = yield (0, _effects.select)((0, _userSelectors.selectUserSession)(action.instanceId));
  const sessionState = (_userSession$characte = userSession.characteristic.find(item => item.name === 'questionnaireState')) === null || _userSession$characte === void 0 ? void 0 : _userSession$characte.value;
  const parsedSessionState = JSON.parse(sessionState);
  if (parsedSessionState !== null && parsedSessionState !== void 0 && (_parsedSessionState$s = parsedSessionState.stateMetadata) !== null && _parsedSessionState$s !== void 0 && _parsedSessionState$s.shareRecommendation) {
    parsedSessionState.stateMetadata.shareRecommendation.status === 'sent' ? yield (0, _effects.put)({
      type: _shareRecommendationActions.SEND_RECOMMENDATION_SUCCESS,
      instanceId: action.instanceId
    }) : yield (0, _effects.put)({
      type: _shareRecommendationActions.SEND_RECOMMENDATION_FAILURE,
      instanceId: action.instanceId
    });
  }
}
function* watchSendRecommendation() {
  yield (0, _effects.takeEvery)(_shareRecommendationActions.SEND_RECOMMENDATION, sendRecommendation);
}
function* watchSaveUserSessionSuccess() {
  yield (0, _effects.takeEvery)(_userActions.SAVE_USER_SESSION_SUCCESS, handleShareRecommendationResponse);
}